export interface InspirationHeroProps {
  title: string;
  description?: string;
  className?: string;
}

export function InspirationHero({
  title,
  description,
  className,
}: InspirationHeroProps) {
  return (
    <div className={className}>
      <h1 className="hd-2xl max-w-[300px] col-span-2 lg:col-span-1">{title}</h1>
      {description && (
        <span className="body-base lg:max-w-[540px] col-span-2">
          {description}
        </span>
      )}
    </div>
  );
}

export default InspirationHero;
